import { Radio, Shield, Clock, FileText, Bell, BarChart3 } from 'lucide-react'
import { FadeIn } from '../../ui/FadeIn'
import { GlassCard } from '../../ui/GlassCard'
import { useLanguage } from '../../../contexts/LanguageContext'

export function OperationsModule() {
  const { t } = useLanguage()

  const operations = [
    {
      icon: Shield,
      labelKey: 'product.operations.checkpoints',
      titleKey: 'product.operations.checkpoints.title',
      descKey: 'product.operations.checkpoints.desc',
      iconColor: 'text-nexus-blue',
    },
    {
      icon: Radio,
      labelKey: 'product.operations.walkie',
      titleKey: 'product.operations.walkie.title',
      descKey: 'product.operations.walkie.desc',
      iconColor: 'text-nexus-cyan',
    },
    {
      icon: Clock,
      labelKey: 'product.operations.patrols',
      titleKey: 'product.operations.patrols.title',
      descKey: 'product.operations.patrols.desc',
      iconColor: 'text-yellow-400',
    },
    {
      icon: FileText,
      labelKey: 'product.operations.reports',
      titleKey: 'product.operations.reports.title',
      descKey: 'product.operations.reports.desc',
      iconColor: 'text-green-400',
    },
    {
      icon: Bell,
      labelKey: 'product.operations.alerts',
      titleKey: 'product.operations.alerts.title',
      descKey: 'product.operations.alerts.desc',
      iconColor: 'text-red-400',
    },
    {
      icon: BarChart3,
      labelKey: 'product.operations.dashboard',
      titleKey: 'product.operations.dashboard.title',
      descKey: 'product.operations.dashboard.desc',
      iconColor: 'text-nexus-blue',
    },
  ]

  return (
    <FadeIn className="h-full">
      <GlassCard className="h-full">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-sm font-semibold tracking-tight">{t('product.operations.title')}</div>
            <div className="mt-1 text-xs text-white/65">
              {t('product.operations.desc')}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <Shield className="size-5 text-nexus-blue" />
            </span>
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <Radio className="size-5 text-nexus-cyan" />
            </span>
          </div>
        </div>

        <div className="mt-5 grid gap-3 sm:grid-cols-2">
          {operations.map((op, index) => {
            const Icon = op.icon
            return (
              <div key={index} className="rounded-2xl border border-white/10 bg-white/6 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon className={`size-4 ${op.iconColor}`} />
                  <div className="text-xs text-white/60">{t(op.labelKey)}</div>
                </div>
                <div className="mt-2 text-sm font-semibold">{t(op.titleKey)}</div>
                <div className="mt-1 text-xs text-white/70">
                  {t(op.descKey)}
                </div>
              </div>
            )
          })}
        </div>
      </GlassCard>
    </FadeIn>
  )
}


